/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_od_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It is a purity indicator. Pure DNA has a ratio near 1.8 and pure RNA near 2.0; a markedly lower ratio suggests contamination by protein or phenol.`)
};

const es_od_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es un indicador de pureza. El ADN puro tiene una relación cercana a 1.8 y el ARN puro cercana a 2.0; una relación notablemente más baja sugiere contaminación por proteína o fenol.`)
};

const de_od_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es ist ein Reinheitsindikator. Reine DNA hat ein Verhältnis von etwa 1,8 und reine RNA von etwa 2,0; ein deutlich niedrigeres Verhältnis deutet auf eine Kontamination durch Protein oder Phenol hin.`)
};

const nl_od_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het is een zuiverheidsindicator. Zuiver DNA heeft een ratio rond 1,8 en zuiver RNA rond 2,0; een duidelijk lagere ratio wijst op contaminatie door eiwit of fenol.`)
};

const fr_od_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est un indicateur de pureté. L'ADN pur a un ratio proche de 1,8 et l'ARN pur proche de 2,0 ; un ratio nettement plus bas suggère une contamination par des protéines ou du phénol.`)
};

const it_od_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È un indicatore di purezza. Il DNA puro ha un rapporto vicino a 1,8 e l'RNA puro vicino a 2,0; un rapporto notevolmente più basso suggerisce contaminazione da proteine o fenolo.`)
};

const pt_br2_od_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É um indicador de pureza. DNA puro tem razão próxima de 1,8 e RNA puro próxima de 2,0; uma razão marcadamente mais baixa sugere contaminação por proteína ou fenol.`)
};

const pt_od_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É um indicador de pureza. O ADN puro tem um rácio próximo de 1,8 e o ARN puro próximo de 2,0; um rácio marcadamente mais baixo sugere contaminação por proteína ou fenol.`)
};

const ja_od_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`純度の指標です。純粋なDNAは比率が1.8前後、純粋なRNAは2.0前後で、それより明らかに低い値はタンパク質やフェノールの混入を示唆します。`)
};

const zh_od_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它是一个纯度指标。纯 DNA 的比值接近 1.8，纯 RNA 接近 2.0；比值明显偏低则提示可能存在蛋白质或苯酚污染。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const od_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.od_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("od_faq_a3", locale)
	if (locale === "en") return en_od_faq_a3(inputs)
	if (locale === "es") return es_od_faq_a3(inputs)
	if (locale === "de") return de_od_faq_a3(inputs)
	if (locale === "nl") return nl_od_faq_a3(inputs)
	if (locale === "fr") return fr_od_faq_a3(inputs)
	if (locale === "it") return it_od_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_od_faq_a3(inputs)
	if (locale === "pt") return pt_od_faq_a3(inputs)
	if (locale === "ja") return ja_od_faq_a3(inputs)
	return zh_od_faq_a3(inputs)
};